import { ReactNode, useEffect } from "react";
import { PostHogProvider, usePostHog } from "@posthog/react";
import type { PostHogConfig } from "posthog-js";

const USER_ID_PREFIX = "user-";

const postHogOptions: Partial<PostHogConfig> = {
  autocapture: false,
  capture_pageview: false,
  disable_session_recording: true,
};

type PostHogAnalyticsProviderProps = {
  children: ReactNode;
  isEnabled: boolean;
  userId: number | null;
};

const PostHogUserIdentity = ({ userId }: { userId: number | null }) => {
  const posthog = usePostHog();

  useEffect(() => {
    if (userId) {
      posthog.identify(`${USER_ID_PREFIX}${userId}`);
    } else if (posthog.get_distinct_id().startsWith(USER_ID_PREFIX)) {
      posthog.reset();
    }
  }, [posthog, userId]);

  return null;
};

const PostHogAnalyticsProvider = ({
  children,
  isEnabled,
  userId,
}: PostHogAnalyticsProviderProps) => {
  if (!isEnabled || !window.POSTHOG_PUBLIC_API_KEY) {
    return <>{children}</>;
  }

  return (
    <PostHogProvider apiKey={window.POSTHOG_PUBLIC_API_KEY} options={postHogOptions}>
      <PostHogUserIdentity userId={userId} />
      {children}
    </PostHogProvider>
  );
};

export default PostHogAnalyticsProvider;
